export default __webpack_public_path__ + "static/media/meme_up_white.172e71ac.svg";